import http from '@/support/plugin/axios'

export const 

//Pegar Notificações
getNotificationsByCurrentContactIdAndCompanyId = ( companyId ) => http.get(`companies/${companyId}/contacts/current/notifications`)